const journal = {
	name: 'Journals',
	fields: {
		primanota: 'Primanota',
		booking_date: 'Journal Date',
		contra_account_id: 'Contra Account',
		debit: 'Debit',
		credit: 'Credit',
		opening_balance: 'Opening balance',
		booking_text: 'Journal Text',
		comments_count: 'Comments',
		document_container_id: 'Document',
		review_state: 'Approved',
	},
}

export default journal
